import { atom } from 'recoil';
import { RECOIL_KEY } from '@constants/recoilKeys';

export const selectedTransportAtom = atom<any>({
  key: RECOIL_KEY.SELECTED_TRANSPORT,
  default: [],
});
